const state = {
  showSaveSearchButton: false,
  publishedFromDate: "",
  publishedToDate: "",
  streamingPublishedFromDate: "",
  streamingPublishedToDate: "",
  metadataAdToDate: "",
  metadataProgramToDate: "",
  latestDay: "",
  excelExportFilePreName: "",
  excelExportTextInFile: "",
  lightAccess: false,
  advertiserAccess: false,
  fullAccess: false,
  mmsUser: false,
  internalAndMMSOnly: false,
  videoInHomeAccess: false,
  expandSavedSearchesSidebar: false
};
const getters = {
  getShowSaveSearchButton: () => state.showSaveSearchButton,
  getPublishedFromDate: state => state.publishedFromDate,
  getPublishedToDate: state => state.publishedToDate,
  getStreamingPublishedFromDate: state => state.streamingPublishedFromDate,
  getStreamingPublishedToDate: state => state.streamingPublishedToDate,
  getMetadataAdToDate: state => state.metadataAdToDate,
  getMetadataProgramToDate: state => state.metadataProgramToDate,
  getLatestDay: state => state.latestDay,
  getExcelExportFilePreName: state => state.excelExportFilePreName,
  getExpandSavedSearchesSidebar: state => state.expandSavedSearchesSidebar
};
const mutations = {
  setShowSaveSearchButton: (state, payload) => (state.showSaveSearchButton = payload),
  setLightAccess: (state, payload) => (state.lightAccess = payload),
  setAdvertiserAccess: (state, payload) => (state.advertiserAccess = payload),
  setFullAccess: (state, payload) => (state.fullAccess = payload),
  setMmsUser: (state, payload) => (state.mmsUser = payload),

  setPublishedFromDate: (state, payload) => (state.publishedFromDate = payload),
  setPublishedToDate: (state, payload) => (state.publishedToDate = payload),
  setStreamingPublishedFromDate: (state, payload) =>
    (state.streamingPublishedFromDate = payload),
  setStreamingPublishedToDate: (state, payload) =>
    (state.streamingPublishedToDate = payload),
  setMetadataAdToDate: (state, payload) => (state.metadataAdToDate = payload),
  setMetadataProgramToDate: (state, payload) =>
    (state.metadataProgramToDate = payload),
  setLatestDay: (state, payload) => (state.latestDay = payload),
  setExcelExportFilePreName: (state, payload) =>
    (state.excelExportFilePreName = payload),
  setExcelExportTextInFile: (state, payload) =>
    (state.excelExportTextInFile = payload),
  setInternalAndMMSOnly(state, value) {
    state.internalAndMMSOnly = value;
  },
  setVideoInHomeAccess: (state, payload) => (state.videoInHomeAccess = payload),
  setExpandSavedSearchesSidebar: (state, payload) => (state.expandSavedSearchesSidebar = payload)
};

export default {
  state,
  mutations,
  getters
};
